import { useState } from 'react'
import Image from '../images/EP_RajKap.JPG'
import SectionHead from "./SectionHead"
import {GiCutDiamond} from 'react-icons/gi'
import { AiFillCaretRight } from 'react-icons/ai'
import { values } from '../data'
import Card from '../UI/Card'
import { PassPurchaseModal } from './PassPurchaseModal'

const VALUES_TO_PASS_TYPE = {
  1: null,           // id 1 if it exists
  2: 'pass4',        // Class Passes
  3: 'member2x',     // Subscriptions
  4: 'dropin',       // Drop-in Classes
  6: null,           // New Student Special — email only
}

const Values = () => {
  const [showModal, setShowModal]   = useState(false)
  const [passType, setPassType]     = useState('pass4')

  const handleSelect = (id, path) => {
    const pt = VALUES_TO_PASS_TYPE[id]
    if (pt) {
      setPassType(pt)
      setShowModal(true)
    } else {
      window.location.href = path
    }
  }

  return (
    <section className="values">
      <div className="container values__container">
        <div className="values__left">
          <div className="values__image">
            <img src={Image} alt="values" />
          </div>
        </div>
        <div className="values__right">
          <SectionHead icon={<GiCutDiamond/>} title="Packages" />
          <p className='tertiary'>
            Ready to make a commitment to your practice with us? We're happy to have you! Choose from our variety of packages to suit your needs and wallet. Please be aware that you will have to sign a contract for memberships.
          </p>
          <div className='values__wrapper'>
            {values.map(({ id, icon, title, description, path }) => (
              <Card key={id} className="values__value">
                <span>{icon}</span>
                <h4>{title}</h4>
                <small>{description}</small>
                <button
                  className='btn sm'
                  onClick={() => handleSelect(id, path)}
                >
                  Select<AiFillCaretRight />
                </button>
              </Card>
            ))}
          </div>
          <p className='tertiary'>
            *All packages are non-refundable and non-transferable.
            <br />
            "New Student Special" is for new students only. You'll be directed to email us to request a link to the package. Thank you.
          </p>
        </div>
      </div>
      {showModal && (
       <PassPurchaseModal
        prefillPassType={passType}
        onClose={() => setShowModal(false)}
      />
      )}
    </section>
  )
}

export default Values